import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addProductOption: {
    id: 'ordering.customizations.addProductOptions',
    defaultMessage: 'Add {productOptionName}',
    description:
      'The label value for adding a product option when it is inactive',
  },
  none: {
    id: 'ordering.pdp.selectWrapper.none',
    defaultMessage: 'None',
    description: 'Provides an option in a dropdown menu to say "None"',
  },
});

export default messages;
